"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenOfferButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _classnames = _interopRequireDefault(require("classnames"));
var _reactDeviceDetect = require("react-device-detect");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tooltip = _interopRequireWildcard(require("../../../../../ui/Tooltip"));
var _Button = _interopRequireWildcard(require("../../../../../ui/Button"));
var _open_in_new = _interopRequireDefault(require("./open_in_new.svg"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var OpenOfferButton = exports.OpenOfferButton = function OpenOfferButton(_ref) {
  var className = _ref.className,
    page = _ref.page;
  var _useTranslation = (0, _reactI18next.useTranslation)('RESULT_CARD'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_Tooltip.default.RenderWhen, {
    content: t('OPEN_TOUR_IN_A_NEW_TAB'),
    isTrue: _reactDeviceDetect.isDesktop,
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _classnames.default)(_styles.default.button, className),
    icon: _open_in_new.default,
    theme: _Button.THEMES.TRANSPARENT,
    onClick: function onClick() {
      global.open(page, '_blank');
    }
  }));
};
OpenOfferButton.propTypes = {
  className: _propTypes.default.string,
  page: _propTypes.default.string.isRequired
};